export default "__VITE_ASSET__BOyqPUPT__"